import React from "react";
import { Spinner as BaseUISpinner, SpinnerProps as BaseSpinnerProps, SIZE } from "baseui/spinner";

type SpinnerProps = Omit<BaseSpinnerProps, "$size"> & { size?: string };

export const Spinner = ({ size = SIZE.medium }: SpinnerProps) => {
  return <BaseUISpinner $size={size} />;
};
